export const CHEQUE_BOUNCE_REASONS = [
  'Funds insufficient',
  'Exceeds arrangement',
  'Effects not cleared, present again.',
  'Refer to drawer',
  'Kindly contact Drawer/Drawee Bank and please present again.',
  "Drawer's signature incomplete",
  "Drawer's signature illegible",
  "Drawer's signature differs",
  "Drawer's signature required",
  "Drawer's signature not as per mandate",
  "Drawer's signature to operate account not received",
  "Drawer's authority to operate account not received",
  "Alteration requires drawer's authentication",
  'Payment stopped by drawer',
  'Payment stopped by attachment order',
  'Payment stopped by court order',
  'Withdrawal stopped owing to death of account holder',
  'Withdrawal stopped owing to lunacy of account holder',
  'Withdrawal stopped owing to insolvency of account holder',
  'Instrument post dated',
  'Instrument out dated/stale',
  'Instrument undated/ without proper date',
  "Instrument mutilated; requires Bank's guarantee",
  'Cheque irregularly drawn/ amount in words and figures differs',
  'Clearing House stamp/ date required',
  'Wrongly delivered/ Not drawn on us',
  'Present in proper zone',
  'Instrument contains extraneous matter',
  'Image not clear, present again with paper',
  'Present with document',
  'Item listed twice',
  'Paper not received',
  'Account closed',
  'Account transferred to another branch',
  'No such account',
  'Title of account required',
  'Title of account wrong/ incomplete',
  'Account blocked (situation covered in 21-25)',
  'Crossed to two banks',
  'Crossing stamp not cancelled',
  'Clearing stamp not cancelled',
  'Instrument specially crossed to another bank',
  'Amount in protective crossing incorrect',
  'Amount in protective crossing required/illegible',
  "Payee's endorsement required",
  "Payee's endorsement irregular / requires collecting bank's confirmation",
  'Endorsement by mark/ thumb impression requires attestation by Magistrate with seal',
  'Advice not received',
  'Amount / Name differs on advice',
  "Drawee bank's fund with sponsor bank insufficient",
  "Payee's separate discharge to bank required",
  'Not payable till 1st proximo',
  'Pay order/ cheque requires counter signature',
  'Required information not legible/ correct',
  "Bank's certificate ambiguous/ incomplete/ required",
  'Draft lost by issuing office/ confirmation required from issuing office',
  'Bank/Branch blocked',
  'Digital Certificate Validation failure',
  'Other reasons-connectivity failure',
  "Alterations on instrument- Other than 'Date' field",
  'Fake/Forged/Stolen-draft/cheque/cash order/interest warrant/dividend warrant',
  "'Payee's a/c credited'- Stamp required",
  'Other reasons (Please specify)',
  'Bank Excluded',
  'Other'
];
